module.exports = __webpack_public_path__ + "media/2.5acb3544.mp3";